import { createAsyncThunk } from '@reduxjs/toolkit';

import { TrackingEventEnum } from '../../../../main/constants/tracking-event.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { AppStateEnum } from '../../../../main/types/app-state.types.ts';

import { updateAppStateThunk } from '../../app-state/thunks/update-app-state.thunk.ts';
import { trackProgressionEventThunk } from '../../progress/thunks/track-progression-event.thunk.ts';

import { LESSON_SLICE_NAME } from '../lesson.slice.types.ts';

const THUNK_NAME = `${LESSON_SLICE_NAME}/abortCurrentStepThunk`;

export const abortCurrentStepThunk = createAsyncThunk<void, void, ThunkApiConfigType>(
  THUNK_NAME,
  async (_, thunkAPI): Promise<void> => {
    await thunkAPI.dispatch(updateAppStateThunk({ state: AppStateEnum.Aborting })).unwrap();
    thunkAPI.dispatch(trackProgressionEventThunk({ event: TrackingEventEnum.STEP_ABORTED }));
  }
);
